import { LUMA_CALENDAR_EMBED_URL } from "../config/events";

export const LumaCalendarEmbed = () => {
  if (!LUMA_CALENDAR_EMBED_URL) {
    return null;
  }

  return (
    <div className="overflow-hidden rounded-lg border border-slate-700/80 bg-black">
      <iframe
        src={LUMA_CALENDAR_EMBED_URL}
        title="Pickles, Tacos, and Tech — upcoming events on Luma"
        className="block h-[200px] w-full border-0"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
};
